<template>
  <div>
    <v-tooltip v-model="show" top>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          class="fw-bold white--text"
          :color="color"
        >
          <slot
        /></v-chip>
      </template>
      <span>{{ content }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    color: String,
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>